import { useState } from 'react'
import { GoogleMarker, MapCenterMarkerProps, MapInitProps, useMapProps } from '../types'
import pin from '../../../../../../assets/images/pin.png'
import React from 'react'

const useMapCenterMarker = (
    map: MapInitProps['mapObject'],
    center: useMapProps['center'],
    onCenterChanged: useMapProps['onCenterChanged']
): MapCenterMarkerProps => {
    const [centerMarker, setCenterMarker] = useState<GoogleMarker>()

    // unmount marker
    React.useEffect(() => {
        if (!center) {
            if (centerMarker) centerMarker.setMap(null)
            setCenterMarker(undefined)
        }
    }, [center, centerMarker])

    React.useEffect(() => {
        if (center && map) {
            if (!centerMarker) {
                const marker: GoogleMarker = new google.maps.Marker({
                    position: center,
                    draggable: true,
                    icon: {
                        url: pin,
                    },
                    anchorPoint: new google.maps.Point(16, 32),
                })

                google.maps.event.addListener(marker, 'dragend', function (e) {
                    onCenterChanged({ lat: e.latLng.lat(), lng: e.latLng.lng() })
                })

                marker.setMap(map)
                setCenterMarker(marker)
            } else centerMarker.setPosition(center)
        }
    }, [center, centerMarker, map, onCenterChanged])

    return {
        centerMarker,
    }
}
export default useMapCenterMarker
